/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import CompanyVerification from '../CompanyVerification'
import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'
import { ServerError, useMutation } from '@apollo/client'
import mutations from '../../../../setup/graphql/mutations'
import Alert from '../../../../_metronic/partials/alert'
import { fetchStart, fetchStop } from '../../../../redux/actions/common'
import { setLoanApplication, setLoanSubStep } from '../redux/actions'
import BankStatementValidator from '../../../../components/BankStatementValidator/BankStatementValidator'
import { generatePerfiosReport } from '../../../../components/BankStatementValidator/utils/perfiosTransaction'
import { areAllFsYearsComplete } from '../utils/fsValidation'
import { CustomLoaderModal } from '../../../../_metronic/helpers/components/CustomLoaderModal'

import { Modal } from 'react-bootstrap-v5'
import { AlexiApplicationTypes } from '../../../../utils/constants/AlexiApplicationType.enum'
import { Stack } from 'react-bootstrap'
import { UploadIcon } from '../../../../svg/UploadIcon'
import { Xicon } from '../../../../svg/Xicon'
import { LeftArowIcon } from '../../../../svg/LeftArowIcon'
import { useHistory } from 'react-router-dom'
import { RightAeroIcon } from '../../../../svg/RightAeroIcon'
import { CheckCircleIcon } from '../../../../svg/CheckCircleIcon'
import FileUploadInfo from '../../../../components/BankStatementValidator/FileUploadInfo/FileUploadInfo'
import FinancialStatementsUpload from '../components/FinancialStatementsUpload'
import { cleanFileNameDynamic } from '../../../constants/commonFunctions'
import {
  addFinancialYear,
  uploadFinancialStatements,
} from '../../../../components/BankStatementValidator/utils/fsTransaction'

const Step2: FC = ({
  // prevStep,
  // goToStep,
  getApplication,
  updateApplication,
}: any) => {
  const dispatch = useDispatch()
  const xlsxRef: any = useRef()
  const history: any = useHistory()
  const [openCustomLoaderModal, setOpenCustomLoaderModal] = useState<boolean>(false)
  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertMsg, setAlertMsg] = useState<string>('')
  const [alertType, setAlertType] = useState<any>('primary')
  const [openVerification, setOpenVerification] = useState(false)
  const [fileGroup, setFileGroup] = useState<any>([])
  const [validateStmtsNow, setValidateStmtsNow] = useState<boolean>(true)
  const [reuploadWarningModal, setReuploadWarningModal] = useState<boolean>(false)
  const [removeAllUploadedStatements, setRemoveAllUploadedStatements] = useState<boolean>(false)
  const [isBankReportGenerated, setIsBankReportGenerated] = useState<boolean>(false)
  const [uploadedFiles, setUploadedFiles] = useState<any>([])
  const [isUploading, setIsUploading] = useState<boolean>(false)
  const [uploadedCorrectStatements, setUploadedCorrectStatements] = useState(false)
  const [pendingFs, setPendingFs] = useState<
    Array<{ id: string; year: number; file: File; filename: string }>
  >([])

  const [createIncomeDocument, onSuccessCreateIncomeDocument] = useMutation(
    mutations.CREATE_INCOME_DOCUMENTS
  )
  const [deleteIncomeDocument] = useMutation(mutations.DELETE_INCOME_DOCUMENT)

  const loanApplication = useSelector((state: any) => state.loan.loanApplication)
  const loanType = localStorage.getItem('loanType')
  const queueFsFile = (year: number, file: File, prefixedName: string) => {
    const currentYear = new Date().getFullYear()
    const yearKey = year === currentYear - 3 ? 'y1' : year === currentYear - 2 ? 'y2' : 'y3'
    const tempId = `temp-fs-${yearKey}`

    // Only remember for addFinancialYear later; do NOT push any temp into fileGroup
    setPendingFs((prev) => {
      const filtered = prev.filter((p) => p.id !== tempId)
      return [...filtered, { id: tempId, year, file, filename: prefixedName }]
    })
  }

  useEffect(() => {
    if (loanApplication?.incomeDocuments) {
      const { incomeDocuments } = loanApplication
      let file = []
      for (const document of incomeDocuments) {
        const _file = {
          id: document.id,
          type: document.type,
          file: document.documentFile,
        }
        file.push(_file)
      }

      const bankStatements = file.filter(({ type }: any) => type === 'bank-statement')
      if (
        bankStatements &&
        bankStatements.length &&
        loanApplication?.bankStatementsReportFileName &&
        loanApplication?.bankStatementsReportFilePath
      ) {
        setIsBankReportGenerated(true)
      }

      setValidateStmtsNow(loanApplication?.perfiosIntegration)
      setFileGroup(file)
    }
  }, [loanApplication, loanApplication?.incomeDocuments])

  useEffect(() => {
    if (removeAllUploadedStatements) {
      handleRemoveAllIncomeDocuments()
    }
  }, [removeAllUploadedStatements])

  useEffect(() => {
    if (onSuccessCreateIncomeDocument.called && !onSuccessCreateIncomeDocument.loading) {
      dispatch(fetchStop())
      if (onSuccessCreateIncomeDocument.data) {
        if (onSuccessCreateIncomeDocument.data) {
          const { createIncomeDocuments } = onSuccessCreateIncomeDocument.data
          let file = [...fileGroup]
          for (const document of createIncomeDocuments) {
            const _file = {
              id: document.id,
              type: document.type,
              file: document.documentFile,
            }
            file.push(_file)
          }

          setFileGroup(file)

          if (loanApplication.applicationCompleteStep < 2) {
            updateApplication({
              variables: {
                data: { applicationCompleteStep: 2 },
                where: { id: loanApplication.id },
              },
            })
          }

          onSuccessCreateIncomeDocument.reset()
        }
      } else {
      }

      if (onSuccessCreateIncomeDocument.error) {
        const { networkError } = onSuccessCreateIncomeDocument.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        const error = `${onSuccessCreateIncomeDocument.error.message},Please try refreshing page agian or if issue persists please contact support (loansupport@ccrpartners.co)`
        setShowAlert(true)
        setAlertMsg(errorList || error)
        setAlertType('primary')
      }
    }
  }, [
    onSuccessCreateIncomeDocument.loading,
    onSuccessCreateIncomeDocument.data,
    onSuccessCreateIncomeDocument.error,
    onSuccessCreateIncomeDocument.called,
  ])

  const isValidFile = (event: any, fileTypes: string[], docType: string = '') => {
    const excelTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-excel', // .xls
      'application/octet-stream', // Some Excel files might have this type
      'application/zip', // .xlsx is actually a zip file
    ]

    const isExcelFile = (file: File) => {
      const fileName = file.name.toLowerCase()
      return (
        excelTypes.includes(file.type) ||
        fileName.endsWith('.xlsx') ||
        fileName.endsWith('.xls') ||
        file.type === ''
      ) // Sometimes Excel files might not have a type
    }

    const isPdfFile = (file: File) => {
      return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')
    }

    const isValidType = (file: File) => {
      if (fileTypes.includes('application/pdf') && isPdfFile(file)) return true
      if (
        (fileTypes.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
          fileTypes.includes('application/vnd.ms-excel')) &&
        isExcelFile(file)
      )
        return true
      return fileTypes.includes(file.type)
    }

    const checkType = [...event.target.files].some((file: File) => !isValidType(file))
    if (checkType) {
      const docTypeDisplay = getDocTypeDisplay(docType)

      setShowAlert(true)
      setAlertMsg(`Please upload a valid ${docTypeDisplay}`)
      setAlertType('primary')

      // Clear the file input
      event.target.value = ''
      event.target.files = null
      return false
    }
    return true
  }

  const getDocTypeDisplay = (docType: string): string => {
    switch (docType) {
      case 'bank-statement':
        return 'Bank Statement'
      case 'revenue-financing-statement':
        return 'Revenue Financing Statement'
      case 'financial-statement':
        return 'Financial Statement'
      case 'company-loan-declaration':
        return 'Company Loan Declaration'
      case 'cs-iras-form':
        return 'C/C-S form'
      default:
        return 'File'
    }
  }

  const handleFileUpload = (
    event: any,
    type: string,
    fileType: string[] = ['application/pdf'],
    year?: number
  ) => {
    if (event.target.validity.valid) {
      let files = []
      let uploadDocs = []

      const isValid = isValidFile(event, fileType, type)

      if (isValid) {
        for (let file of event.target.files) {
          const isExists = fileGroup.some((f: any) => {
            return (
              cleanFileNameDynamic(f.file.filename) === cleanFileNameDynamic(file.name) &&
              f.type === type
            )
          })

          if (!isExists) {
            /**
             * FINANCIAL STATEMENT YEAR PREFIXING LOGIC
             *
             * For financial statements, we prepend a year-specific prefix to filenames
             * to organize files by year boxes. This ensures files uploaded to specific
             * year boxes remain in those boxes permanently.
             *
             * Year Key Mapping (HARDCODED for data consistency):
             * - y1- prefix = 2022 files (Past year 1)
             *
             * Example: "statement.pdf" uploaded to 2022 box becomes "y1-statement.pdf"
             */
            if (type === 'financial-statement' && year) {
              // Determine year key based on financial year mapping
              // If current year is 2025: y1=2022, y2=2023, y3=2024 (for FY 2024-25)
              const currentYear = new Date().getFullYear()
              const yearKey =
                year === currentYear - 3 ? 'y1' : year === currentYear - 2 ? 'y2' : 'y3'

              // Create a new File object with the prefixed filename
              // This ensures the actual uploaded file has the correct name
              const newFile = new File([file], `${yearKey}-${file.name}`, { type: file.type })

              // Add custom filename property for internal tracking and display
              Object.defineProperty(newFile, 'filename', {
                value: `${yearKey}-${file.name}`,
                writable: true,
              })

              files.push({ type: type, file: newFile })
            } else {
              // For non-financial statement files, use original filename
              Object.defineProperty(file, 'filename', {
                value: file.name,
                writable: true,
              })
              files.push({ type: type, file })
            }

            uploadDocs.push({
              application: {
                connect: {
                  id: loanApplication.id,
                },
              },
              type: type,
              documentFile: {
                upload: files[files.length - 1]?.file || file,
              },
            })

            if (
              loanType &&
              loanType.toLowerCase() === AlexiApplicationTypes.RECURRING_APPLICATION
            ) {
              event.target.value = ''
              if (xlsxRef?.current?.value) {
                xlsxRef.current.value = null
              }
            }
          } else {
            event.target.value = ''
            setShowAlert(true)
            setAlertMsg('File already exists')
            setAlertType('primary')
            return
          }
        }

        if (files.length) {
          event.target.value = ''
          createIncomeDocument({
            variables: {
              data: uploadDocs,
            },
          })

          dispatch(fetchStart())
        }
        event.target.value = ''
      }
    }
  }

  const handleRemoveAllIncomeDocuments = () => {
    try {
      if (fileGroup && fileGroup?.length) {
        const allIncomeDocs = fileGroup.filter(({ type }: any) => type === 'bank-statement')
        const otherDocs = fileGroup.filter(({ type }: any) => type !== 'bank-statement')
        for (const file of allIncomeDocs) {
          deleteIncomeDocument({
            variables: {
              where: { id: file.id },
            },
          })
        }
        updateApplication({
          variables: {
            data: {
              applicationCompleteStep: 2,
              bankStatementsReportFileName: '',
              bankStatementsReportFilePath: '',
              bankStatementsXlsxReportFileName: '',
              bankStatementsXlsxReportFilePath: '',
            },
            where: { id: loanApplication.id },
          },
        })
        setIsBankReportGenerated(false)
        setFileGroup(otherDocs)
      }
    } catch (error) {
      throw error
    }
  }

  const handleStatementUpload = async (type: string = '') => {
    try {
      let files = []
      let uploadDocs = []

      for (let file of uploadedFiles) {
        const { response, ...restFileData } = file
        file.filename = file.name
        files.push({ type: type, restFileData })
        uploadDocs.push({
          application: {
            connect: {
              id: loanApplication.id,
            },
          },
          type: type,
          documentFile: {
            upload: file,
          },
        })
      }

      // _fileGroup = _fileGroup.concat(files);
      // setFileGroup(_fileGroup);

      return createIncomeDocument({
        variables: {
          data: uploadDocs,
        },
      }).then((response: any) => {
        const { createIncomeDocuments } = response?.data

        return createIncomeDocuments
      })
    } catch (error) {
      throw error
    }
  }

  const submitAll = async () => {
    try {
      setOpenCustomLoaderModal(true)

      // 1) If we have a pending current-FY file, register FY first, then upload it
      // 1) Register current-FY (y3) with addFinancialYear only; files already uploaded via GraphQL above
      if (pendingFs.length) {
        for (const p of pendingFs) {
          try {
            await addFinancialYear(p.file, p.year.toString(), loanApplication.id, true)
          } catch (e) {
            console.error('addFinancialYear (current FY) failed on submit:', e)
            // continue; we proceed with the rest
          }
        }
        setPendingFs([])
      }

      // 2) Trigger final FS consolidation/upload job
      try {
        await uploadFinancialStatements()
      } catch (fsError) {
        setShowAlert(true)
        setAlertMsg('Failed to upload financial statements')
        setAlertType('primary')
        return
      }

      // 3) Existing bank statement path unchanged...
      if (
        validateStmtsNow &&
        (!loanApplication.bankStatementsReportFilePath || removeAllUploadedStatements)
      ) {
        const report = await retrieveBankReport()
        const incomeDocs: any = await handleStatementUpload('bank-statement')
        updateApplication({
          variables: {
            data: {
              applicationCompleteStep: 2,
              bankStatementsReportFileName: report?.reportFileName,
              bankStatementsReportFilePath: report?.reportFilePath,
              bankStatementsXlsxReportFileName: report?.reportXlsxFileName,
              bankStatementsXlsxReportFilePath: report?.reportXlsxFilePath,
            },
            where: { id: loanApplication.id },
          },
        })
        const applications = {
          ...loanApplication,
          incomeDocuments: [...loanApplication.incomeDocuments, ...incomeDocs],
          applicationCompleteStep: 2,
          bankStatementsReportFileName: report?.reportFileName,
          bankStatementsReportFilePath: report?.reportFilePath,
          bankStatementsXlsxReportFileName: report?.reportXlsxFileName,
          bankStatementsXlsxReportFilePath: report?.reportXlsxFilePath,
        }
        dispatch(setLoanApplication(applications))
        setUploadedFiles([])
        setIsBankReportGenerated(true)
        setOpenCustomLoaderModal(false)
      }
      setOpenCustomLoaderModal(false)
      setOpenVerification(true)
    } catch (error: any) {
      setOpenCustomLoaderModal(false)
      setShowAlert(true)
      setAlertMsg(error?.response?.data?.message || error?.response?.data || error?.message)
      setAlertType('primary')
    }
  }

  /**
   * Calls generate report api
   * @returns report details uploaded on azure
   */
  const retrieveBankReport = async () => {
    try {
      const report = await generatePerfiosReport(
        loanApplication?.id,
        `${loanApplication?.id}_report`,
        loanApplication?.applicationType
      )
      return report
    } catch (error) {
      console.log(error)
      throw error
    }
  }

  const removeSingleFile = async (id: string) => {
    if (id.startsWith('temp-fs-')) {
      setPendingFs((prev) => prev.filter((p) => p.id !== id))
      setFileGroup((prev: any[]) => prev.filter((o: any) => o.id !== id))
      return
    }
    const _fileGroup = fileGroup.filter((o: any) => o.id !== id)
    setFileGroup(_fileGroup)
    await deleteIncomeDocument({ variables: { where: { id } } })
  }

  const reuploadAccepted = () => {
    setValidateStmtsNow(!validateStmtsNow)
    setReuploadWarningModal(false)
    handleRemoveAllIncomeDocuments()
    setUploadedFiles([])
  }

  function backLink() {
    dispatch(setLoanSubStep(3))
    history.replace(`/application/${loanApplication.id}?step=1.3`)
  }

  return (
    <div className='d-flex flex-column flex-column-fluid'>
      <div className='cardNew'>
        <div className='section-heading'>
          <h2>
            Bank Statements {uploadedCorrectStatements && <CheckCircleIcon color='var(--sucess)' />}
            {validateStmtsNow &&
              loanApplication.bankStatementsReportFilePath &&
              fileGroup.length &&
              fileGroup.some(({ type }: any) => type === 'bank-statement') &&
              !removeAllUploadedStatements &&
              !uploadedCorrectStatements && <CheckCircleIcon color='var(--warning)' />}
          </h2>
          <hr className='text-gray-400' />
        </div>
        <div>
          {validateStmtsNow && (
            <div className='card-body'>
              <BankStatementValidator
                refId={loanApplication?.id}
                refType={loanApplication?.applicationType}
                setUploadedCorrectStatements={setUploadedCorrectStatements}
                setUploadedFiles={setUploadedFiles}
                setIsBankReportGenerated={setIsBankReportGenerated}
                isBankReportGenerated={isBankReportGenerated}
                removeAllUploadedStatements={setRemoveAllUploadedStatements}
                validateMonthsTill={6}
                setIsBankStatementUploading={setIsUploading}
              />
            </div>
          )}
          {!validateStmtsNow && (
            <>
              <div className='bank-statement-upload mb-3 rounded' style={{ width: '100%' }}>
                <FileUploadInfo />
              </div>
              <div
                className='uploadBox'
                style={{
                  border: '1px dashed var(--primary-color)',
                  padding: '63px 40px',
                  background: 'var(--primary-light-color)',
                  minHeight: '150px',
                  fontSize: '14px',
                  marginBottom: '15px',
                  borderRadius: '10px',
                  alignItems: 'center',
                }}
              >
                <Stack
                  style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  gap={2}
                >
                  <div className='upload mb-4'>
                    <input
                      id='upload-file-bank'
                      type='file'
                      multiple
                      accept='application/pdf'
                      onChange={(e: any) => handleFileUpload(e, 'bank-statement')}
                      onDrop={(e: React.DragEvent) => {
                        console.log(e)
                        e.preventDefault()
                        e.stopPropagation()
                        const files = e.dataTransfer.files
                        if (files.length) {
                          const event = { target: { files, validity: { valid: true } } }
                          handleFileUpload(event, 'bank-statement', ['application/pdf'])
                        }
                      }}
                      onDragOver={(e: React.DragEvent) => {
                        e.preventDefault()
                        e.stopPropagation()
                      }}
                      onDragLeave={(e: React.DragEvent) => {
                        e.preventDefault()
                        e.stopPropagation()
                      }}
                    ></input>
                    <label
                      htmlFor='upload-file-bank'
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        paddingTop: '10px',
                      }}
                    >
                      <div
                        className='file-uploader'
                        style={{
                          cursor: 'pointer',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                        }}
                      >
                        <UploadIcon color='var(--primary-color)' />
                        <span className='dragDropTitle'>Drag & Drop Bank Statements</span>
                      </div>
                      <div className='file-uploader-sub'>Supported format: PDF</div>
                    </label>
                  </div>
                </Stack>
              </div>
              <div className='uploadedCapsulesWrap'>
                <Stack
                  className='uploadedCapsules gridCapsules'
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(6, 1fr)',
                    gap: '12px',
                    fontSize: '12px',
                    minWidth: '100%',
                  }}
                >
                  {fileGroup && fileGroup.length > 0 && (
                    <>
                      {fileGroup
                        .filter(({ type }: any) => type === 'bank-statement')
                        .map(({ file, type, id }: any, i: number) => {
                          const filename = file.filename.split('.')
                          const name = filename[0].substring(0, 15)
                          const extension = filename[1]

                          return (
                            <div
                              key={i}
                              style={{
                                fontSize: 14,
                                color: '#616B75',
                                background: '#F9FAFA',
                                padding: '8px 16px',
                                display: 'flex',
                                borderRadius: '20px',
                                border: '1px solid #E0E0E0',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%',
                              }}
                              title={file.filename}
                            >
                              <span>{`${name}...${extension}`}</span>
                              <Xicon
                                onClick={() => removeSingleFile(id)}
                                className='cursor-pointer'
                              />
                            </div>
                          )
                        })}
                    </>
                  )}
                </Stack>
              </div>
            </>
          )}
          {uploadedCorrectStatements ? (
            <div className='text-success'>
              Your Bank Statements have been successfully validated
            </div>
          ) : null}
          {validateStmtsNow &&
          loanApplication.bankStatementsReportFilePath &&
          fileGroup.length &&
          fileGroup.some(({ type }: any) => type === 'bank-statement') &&
          !removeAllUploadedStatements &&
          !uploadedCorrectStatements ? (
            <div className='text-alert'>
              You have already uploaded your bank statements, now you can either re-upload your bank
              statements or proceed further.
            </div>
          ) : null}
        </div>
      </div>

      {loanType && loanType.toLowerCase() === AlexiApplicationTypes.RECURRING_APPLICATION ? (
        <div className='cardNew'>
          <div className='section-heading'>
            <h2>
              Revenue Details{' '}
              {fileGroup &&
                fileGroup.filter(({ type }: any) => type === 'revenue-financing-statement').length >
                  0 && <CheckCircleIcon color='var(--sucess)' />}
            </h2>
            <hr className='text-gray-400' />
          </div>
          <div className='bank-statement-upload mb-3 rounded p-4 '>
            <ul className='fs-4'>
              <li>
                <span>
                  You can download the sample template:{' '}
                  <a
                    href={toAbsoluteUrl('/media/alexi/downloadtemplate.xlsx')}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Download the template
                  </a>
                </span>
              </li>
              <li>
                <span>
                  The instructions are clearly mentioned in the document on how to complete/fill
                </span>
              </li>
              <li>
                <span>
                  Do not change any headers and request you to fill all information requested{' '}
                </span>
              </li>
              <li>
                <span>
                  {' '}
                  Once you fill in the application please upload the file using Browse Files button
                </span>
              </li>
            </ul>
          </div>

          <div
            className='uploadBox'
            style={{
              border: '1px dashed var(--primary-color)',
              padding: '63px 40px',
              background: 'var(--primary-light-color)',
              minHeight: '150px',
              fontSize: '14px',
              marginBottom: '15px',
              borderRadius: '10px',
              alignItems: 'center',
            }}
          >
            <Stack
              style={{
                alignItems: 'center',
                justifyContent: 'center',
              }}
              gap={2} // Increased gap for better spacing
            >
              <div className='upload mb-4'>
                <input
                  id='upload-file-revenue'
                  type='file'
                  multiple
                  accept='.xlsx'
                  onChange={(e: any) =>
                    handleFileUpload(e, 'revenue-financing-statement', [
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    ])
                  }
                  onDrop={(e: React.DragEvent) => {
                    e.preventDefault()
                    e.stopPropagation()
                    const files = e.dataTransfer.files
                    if (files.length) {
                      const event = { target: { files, validity: { valid: true } } }
                      handleFileUpload(event, 'revenue-financing-statement', [
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      ])
                    }
                  }}
                  onDragOver={(e: React.DragEvent) => {
                    e.preventDefault()
                    e.stopPropagation()
                  }}
                  onDragLeave={(e: React.DragEvent) => {
                    e.preventDefault()
                    e.stopPropagation()
                  }}
                ></input>
                <label
                  htmlFor='upload-file-revenue'
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    paddingTop: '10px',
                  }}
                >
                  <div
                    className='file-uploader'
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <UploadIcon color='var(--primary-color)' />

                    <span className='dragDropTitle'>Drag & Drop Revenue Statements</span>
                  </div>
                  <div className='file-uploader-sub'>Supported formats: XLSX, XLS</div>
                </label>
              </div>
            </Stack>
          </div>
          <div className='uploadedCapsulesWrap'>
            <Stack
              className='uploadedCapsules gridCapsules'
              style={{
                display: 'grid', // Change to grid layout
                gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
                gap: '12px', // Adjusted gap for better spacing
                fontSize: '12px',
                minWidth: '100%',
              }}
            >
              {fileGroup && fileGroup.length > 0 && (
                <>
                  {fileGroup
                    .filter(({ type }: any) => type === 'revenue-financing-statement')
                    .map(({ file, type, id }: any, i: number) => {
                      const filename = file.filename.split('.')
                      const name = filename[0].substring(0, 15)
                      const extension = filename[1]

                      return (
                        <div
                          key={i}
                          style={{
                            fontSize: 14,
                            color: '#616B75',
                            background: '#F9FAFA',
                            borderRadius: '20px',
                            border: '1px solid #E0E0E0',
                            padding: '8px 16px',
                            display: 'flex', // Use flex to position items
                            justifyContent: 'space-between', // Space between text and icon
                            alignItems: 'center', // Center items vertically
                            width: '100%', // Set to 100% to fill the grid cell
                          }}
                          title={file.filename}
                        >
                          <span>{`${name}...${extension}`}</span>
                          <Xicon onClick={() => removeSingleFile(id)} className='cursor-pointer' />
                        </div>
                      )
                    })}
                </>
              )}
            </Stack>
          </div>
        </div>
      ) : null}

      {/* {loanApplication.amountRequested > 250000 && ( */}
      <div className='cardNew'>
        <FinancialStatementsUpload
          fileGroup={fileGroup}
          handleFileUpload={handleFileUpload}
          applicationid={loanApplication.id}
          removeSingleFile={removeSingleFile}
          queueFsFile={queueFsFile}
        />
      </div>
      {/* )} */}

      <div className='cardNew'>
        <div className='section-heading'>
          <h2>
            Latest 2 Years' Form C/C-S (Optional)
            {fileGroup &&
              fileGroup.filter(({ type }: any) => type === 'cs-iras-form').length > 0 && (
                <CheckCircleIcon color='var(--sucess)' />
              )}
          </h2>
          <a
            className='text-primary fw-bold'
            style={{
              fontSize: '16px',
              borderBottom: '1px solid currentColor',
              cursor: 'pointer',
              marginTop: '12px',
              display: 'inline-block',
              lineHeight: '1.1',
            }}
            href='https://www.iras.gov.sg/taxes/corporate-income-tax/form-c-s-form-c-s-(lite)-form-c-filing/overview-of-form-c-s-form-c-s-(lite)-form-c'
            target='_blank'
            rel='noopener noreferrer'
          >
            Learn What is Form C/C-S
          </a>
          <hr className='text-gray-400' />
        </div>
        <div
          className='uploadBox'
          style={{
            border: '1px dashed var(--primary-color)',
            padding: '63px 40px',
            background: 'var(--primary-light-color)',
            minHeight: '150px',
            fontSize: '14px',
            marginBottom: '15px',
            borderRadius: '10px',
            alignItems: 'center',
          }}
          onDrop={(e: React.DragEvent) => {
            e.preventDefault()
            e.stopPropagation()
            const files = e.dataTransfer.files
            if (files.length) {
              const event = { target: { files, validity: { valid: true } } }
              handleFileUpload(event, 'cs-iras-form', [
                'application/pdf',
                'application/msword',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
              ])
            }
          }}
          onDragOver={(e: React.DragEvent) => {
            e.preventDefault()
            e.stopPropagation()
          }}
          onDragLeave={(e: React.DragEvent) => {
            e.preventDefault()
            e.stopPropagation()
          }}
        >
          <Stack
            style={{
              alignItems: 'center',
              justifyContent: 'center',
            }}
            gap={2} // Increased gap for better spacing
          >
            <div className='upload mb-4'>
              <input
                id='upload-file-finance'
                type='file'
                multiple
                accept='.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                onChange={(e: any) =>
                  handleFileUpload(e, 'cs-iras-form', [
                    'application/pdf',
                    'application/msword',
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                  ])
                }
                onDrop={(e: React.DragEvent) => {
                  e.preventDefault()
                  e.stopPropagation()
                  const files = e.dataTransfer.files
                  if (files.length) {
                    const event = { target: { files, validity: { valid: true } } }
                    handleFileUpload(event, 'cs-iras-form', [
                      'application/pdf',
                      'application/msword',
                      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                    ])
                  }
                }}
                onDragOver={(e: React.DragEvent) => {
                  e.preventDefault()
                  e.stopPropagation()
                }}
                onDragLeave={(e: React.DragEvent) => {
                  e.preventDefault()
                  e.stopPropagation()
                }}
              ></input>
              <label
                htmlFor='upload-file-finance'
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  paddingTop: '10px',
                }}
              >
                <div
                  className='file-uploader'
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <UploadIcon color='var(--primary-color)' />

                  <span className='dragDropTitle'>Drag & Drop Latest 2 Years' Form C/C-S</span>
                </div>
                <div className='file-uploader-sub'>Supported formats: PDF, DOCX</div>
              </label>
            </div>
          </Stack>
        </div>
        <div className='uploadedCapsulesWrap'>
          <Stack
            className='uploadedCapsules gridCapsules'
            style={{
              display: 'grid', // Change to grid layout
              gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
              gap: '12px', // Adjusted gap for better spacing
              fontSize: '12px',
              minWidth: '100%',
            }}
          >
            {fileGroup && fileGroup.length > 0 && (
              <>
                {fileGroup
                  .filter(({ type }: any) => type === 'cs-iras-form')
                  .map(({ file, type, id }: any, i: number) => {
                    const filename = file.filename.split('.')
                    const name = filename[0].substring(0, 10)
                    const extension = filename[1]

                    return (
                      <div
                        key={i}
                        style={{
                          fontSize: 14,
                          color: '#616B75',
                          background: '#F9FAFA',
                          borderRadius: '20px',
                          border: '1px solid #E0E0E0',
                          padding: '8px 16px',
                          display: 'flex', // Use flex to position items
                          justifyContent: 'space-between', // Space between text and icon
                          alignItems: 'center', // Center items vertically
                          width: '100%', // Set to 100% to fill the grid cell
                        }}
                        title={file.filename}
                        className='capsuleText'
                      >
                        <span>{`${name}...${extension}`}</span>
                        <Xicon onClick={() => removeSingleFile(id)} className='cursor-pointer' />
                      </div>
                    )
                  })}
              </>
            )}
          </Stack>
        </div>
      </div>

      <div className='cardNew'>
        <div className='section-heading'>
          <h2>
            Company Loan Declaration{' '}
            {fileGroup &&
              fileGroup.filter(({ type }: any) => type === 'company-loan-declaration').length >
                0 && <CheckCircleIcon color='var(--sucess)' />}
          </h2>
          <a
            href='https://credilinq-web.s3.ap-southeast-1.amazonaws.com/Loan_Declaration_CCRP.xlsx'
            download
          >
            <button
              style={{ marginTop: '12px' }}
              className='button-download-template button-outline-primary'
            >
              <svg
                width='20'
                height='20'
                viewBox='0 0 20 20'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <g clip-path='url(#clip0_6388_6190)'>
                  <path
                    d='M3.3335 14.1666V15.8333C3.3335 16.2753 3.50909 16.6992 3.82165 17.0118C4.13421 17.3244 4.55814 17.5 5.00016 17.5H15.0002C15.4422 17.5 15.8661 17.3244 16.1787 17.0118C16.4912 16.6992 16.6668 16.2753 16.6668 15.8333V14.1666'
                    stroke='#013238'
                    stroke-width='1.66667'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                  <path
                    d='M5.8335 9.16663L10.0002 13.3333L14.1668 9.16663'
                    stroke='#013238'
                    stroke-width='1.66667'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                  <path
                    d='M10 3.33337V13.3334'
                    stroke='#013238'
                    stroke-width='1.66667'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_6388_6190'>
                    <rect width='20' height='20' fill='white' />
                  </clipPath>
                </defs>
              </svg>
              Download & Fill Template
            </button>
          </a>
          <hr className='text-gray-400' />
        </div>

        <div
          className='uploadBox'
          style={{
            border: '1px dashed var(--primary-color)',
            padding: '63px 40px',
            background: 'var(--primary-light-color)',
            minHeight: '150px',
            fontSize: '14px',
            marginBottom: '15px',
            borderRadius: '10px',
            alignItems: 'center',
          }}
          onDrop={(e: React.DragEvent) => {
            e.preventDefault()
            e.stopPropagation()
            const files = e.dataTransfer.files
            if (files.length) {
              const event = { target: { files, validity: { valid: true } } }
              handleFileUpload(event, 'company-loan-declaration', [
                'application/pdf',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/vnd.ms-excel',
                'application/octet-stream',
              ])
            }
          }}
          onDragOver={(e: React.DragEvent) => {
            e.preventDefault()
            e.stopPropagation()
          }}
          onDragLeave={(e: React.DragEvent) => {
            e.preventDefault()
            e.stopPropagation()
          }}
        >
          <Stack
            style={{
              alignItems: 'center',
              justifyContent: 'center',
            }}
            gap={2} // Increased gap for better spacing
          >
            <div className='upload mb-4'>
              <input
                id='upload-file-finance'
                type='file'
                multiple
                accept='.pdf,.xlsx,.xls,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/octet-stream'
                onChange={(e: any) =>
                  handleFileUpload(e, 'company-loan-declaration', [
                    'application/pdf',
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'application/vnd.ms-excel',
                    'application/octet-stream',
                  ])
                }
                onDrop={(e: React.DragEvent) => {
                  e.preventDefault()
                  e.stopPropagation()
                  const files = e.dataTransfer.files
                  if (files.length) {
                    const event = { target: { files, validity: { valid: true } } }
                    handleFileUpload(event, 'company-loan-declaration', [
                      'application/pdf',
                      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      'application/vnd.ms-excel',
                      'application/octet-stream',
                    ])
                  }
                }}
                onDragOver={(e: React.DragEvent) => {
                  e.preventDefault()
                  e.stopPropagation()
                }}
                onDragLeave={(e: React.DragEvent) => {
                  e.preventDefault()
                  e.stopPropagation()
                }}
              ></input>
              <label
                htmlFor='upload-file-finance'
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  paddingTop: '10px',
                }}
              >
                <div
                  className='file-uploader'
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <UploadIcon color='var(--primary-color)' />

                  <span className='dragDropTitle'>Drag & Drop Company Loan Declaration</span>
                </div>
                <div className='file-uploader-sub'>Supported formats: PDF, XLXS, XLS</div>
              </label>
            </div>
          </Stack>
        </div>
        <div className='uploadedCapsulesWrap'>
          <Stack
            className='uploadedCapsules gridCapsules'
            style={{
              display: 'grid', // Change to grid layout
              gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
              gap: '12px', // Adjusted gap for better spacing
              fontSize: '12px',
              minWidth: '100%',
            }}
          >
            {fileGroup && fileGroup.length > 0 && (
              <>
                {fileGroup
                  .filter(({ type }: any) => type === 'company-loan-declaration')
                  .map(({ file, type, id }: any, i: number) => {
                    const filename = file.filename.split('.')
                    const name = filename[0].substring(0, 10)
                    const extension = filename[1]

                    return (
                      <div
                        key={i}
                        style={{
                          fontSize: 14,
                          color: '#616B75',
                          background: '#F9FAFA',
                          borderRadius: '20px',
                          border: '1px solid #E0E0E0',
                          padding: '8px 16px',
                          display: 'flex', // Use flex to position items
                          justifyContent: 'space-between', // Space between text and icon
                          alignItems: 'center', // Center items vertically
                          width: '100%', // Set to 100% to fill the grid cell
                        }}
                        className='capsuleText'
                        title={file.filename}
                      >
                        <span>{`${name}...${extension}`}</span>
                        <Xicon onClick={() => removeSingleFile(id)} className='cursor-pointer' />
                      </div>
                    )
                  })}
              </>
            )}
          </Stack>
        </div>
      </div>

      {/* commented gst for now  */}
      {/* <div className='cardNew'>
        <div className='section-heading'>
          <h2>
            GST Statements{' '}
            {fileGroup && fileGroup.length > 0 && <CheckCircleIcon color='var(--sucess)' />}
          </h2>
          <hr className='text-gray-400' />
        </div>
        <div className='bank-statement-upload mb-4 rounded p-4 fs-4'>
          PDF (not scanned copies) of the last 12 months / 4 quarters (GST) statements (can be
          downloaded from IRAS website).
        </div>
        <div
          style={{
            border: '1px dashed #BBBFC4',
            padding: '63px 40px',
            background: 'rgba(26,3,85,0.02)',
            minHeight: '150px',
            fontSize: '14px',
            marginBottom: '15px',
            borderRadius: '10px',
            alignItems: 'center',
          }}
        >
          <Stack
            style={{
              alignItems: 'center',
              justifyContent: 'center',
            }}
            gap={2} // Increased gap for better spacing
          >
            <div className='upload  mb-4'>
              <input
                id='upload-file-gst'
                type='file'
                multiple
                accept='application/pdf'
                onChange={(e: any) => {
                  handleFileUpload(e, 'gst-statement')
                }}
              ></input>
              <label
                htmlFor='upload-file-gst'
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  paddingTop: '10px',
                }}
              >
                <div
                  className='file-uploader'
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <UploadIcon color='var(--primary-color)' />

                  <span>Drag & Drop GST Statements</span>
                </div>
                <div className='file-uploader-sub'>Supported format: PDF Only</div>
              </label>
            </div>
          </Stack>
        </div>

        <div className=''>
          <Stack
            style={{
              display: 'grid', // Change to grid layout
              gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
              gap: '12px', // Adjusted gap for better spacing
              fontSize: '12px',
              minWidth: '100%',
            }}
          >
            {fileGroup && fileGroup.length > 0 && (
              <>
                {fileGroup
                  .filter(({ type }: any) => type === 'gst-statement')
                  .map(({ file, type, id }: any, i: number) => {
                    const filename = file.filename.split('.')
                    const name = filename[0].substring(0, 15)
                    const extension = filename[1]

                    return (
                      <div
                        key={i}
                        style={{
                          fontSize: 14,
                          color: '#616B75',
                          background: '#F9FAFA',
                          borderRadius: 4,
                          padding: '8px 16px',
                          display: 'flex', // Use flex to position items
                          justifyContent: 'space-between', // Space between text and icon
                          alignItems: 'center', // Center items vertically
                          width: '100%', // Set to 100% to fill the grid cell
                        }}
                        title={file.filename}
                      >
                        <span>{`${name}...${extension}`}</span>
                        <Xicon onClick={() => removeSingleFile(id)} className='cursor-pointer' />
                      </div>
                    )
                  })}
              </>
            )}
          </Stack>
        </div>
      </div> */}

      <div className='cardNew stickeyFooter'>
        <div className='d-flex justify-content-between'>
          <button className='button button-outline-primary' onClick={backLink}>
            <LeftArowIcon color='currentColor' />
            Back
          </button>
          {(() => {
            // Use the dedicated FS validation function
            const hasValidFinancialPrefixes = areAllFsYearsComplete(fileGroup)
            const shouldDisable = validateStmtsNow
              ? (!isBankReportGenerated && !uploadedCorrectStatements) ||
                !fileGroup.some(({ type }: any) => type === 'financial-statement') ||
                !hasValidFinancialPrefixes ||
                !fileGroup.some(({ type }: any) => type === 'company-loan-declaration')
              : !fileGroup.some(({ type }: any) => type === 'bank-statement') ||
                !fileGroup.some(({ type }: any) => type === 'financial-statement') ||
                !hasValidFinancialPrefixes ||
                !fileGroup.some(({ type }: any) => type === 'company-loan-declaration')
            const btnBg = shouldDisable ? 'grey' : 'var(--secondary-color)'
            return (
              <button
                className='button button-primary'
                style={{
                  background: btnBg,
                }}
                disabled={shouldDisable}
                onClick={() => submitAll()}
              >
                Save and Continue
                <RightAeroIcon color='currentColor' />
              </button>
            )
          })()}
        </div>
      </div>

      {openVerification && (
        <CompanyVerification
          show={openVerification}
          handleClose={() => setOpenVerification(false)}
          // goToStep={goToStep}
        />
      )}

      {showAlert && (
        <Alert variant={alertType} showAlert={showAlert} setShowAlert={setShowAlert}>
          {alertMsg}
        </Alert>
      )}
      <CustomLoaderModal
        openCustomLoaderModal={openCustomLoaderModal}
        setOpenCustomLoaderModal={setOpenCustomLoaderModal}
        message='Please wait while we process your documents. This may take a few moments. Do not refresh or close your browser window.'
      />
      <Modal
        className='bg-transparent'
        id='kt_mega_menu_modal'
        data-backdrop='static'
        aria-hidden='true'
        role='dialog'
        tabIndex='-1'
        contentClassName='shadow-none'
        show={reuploadWarningModal}
      >
        <div className='modal-content'>
          <div className='d-flex align-items-center justify-content-between py-5 ps-8 pe-5 border-bottom'>
            <div>
              <h3 className='fw-bold m-0'>
                Bank Statements Validation Mode
                <div
                  className='btn btn-icon btn-sm btn-light-primary ms-2'
                  data-bs-dismiss='modal'
                  style={{ float: 'right' }}
                  onClick={() => setReuploadWarningModal(false)}
                >
                  <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
                </div>
              </h3>
              <div className='mt-2'>
                Are you sure you want to{' '}
                <b>
                  {!validateStmtsNow
                    ? 'Validate Bank-Statements'
                    : 'Skip Bank-Statements Validation'}
                </b>
                ? This will remove all of your previously uploaded statements.
              </div>
            </div>
          </div>
          <div className='d-flex flex-center mt-5 mb-5'>
            <button className='btn btn-lg btn-primary me-3' onClick={reuploadAccepted}>
              I understand
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export { Step2 }
